import { Link } from "@chakra-ui/react";
import { SKIP_LINK_LABEL } from "@/content";

export const SkipLink = () => (
  <Link
    href="#main"
    className="print-hide"
    position="absolute"
    left="12px"
    top="-60px"
    zIndex={200}
    bg="ink.DEFAULT"
    color="ink.light"
    px="16px"
    py="10px"
    borderRadius="sm"
    transitionProperty="top"
    transitionDuration="0.2s"
    transitionTimingFunction="brand"
    _focus={{ top: "12px" }}
  >
    {SKIP_LINK_LABEL}
  </Link>
);
